import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonButton from '../components/CommonButton';

/**
import CustomDatePicker from '../components/CommonDatePicker';
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/

class SearchSupplyDataSupplyHr extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation, UserCookie } = props;

        let { academy_id, faculty_id } = Searchs;

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">                 
                        <Row className="mt-3">
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{academy_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={academy_id}
                                        option={{source: 'db', data: Masterbase?.academy}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)}
                                        disabled={!['0','1'].includes(UserCookie?.types)}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{faculty_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={academy_id}
                                        option={{source: 'db', data: Masterbase?.faculty}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)}
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>                    
                        </Row>
                    </Col>
                </Row>                
            </>
        )
    }
}

export default SearchSupplyDataSupplyHr;